// Module
var code = "<style>:host{all:inherit;border:none;padding:none;margin:none}</style>";
// Exports
export default code;